<script setup lang="ts">
/**
 * Circular icon button for use inside ImageActionOverlay.
 */
withDefaults(
  defineProps<{
    icon: string
    title: string
    color?: string
    disabled?: boolean
  }>(),
  { color: "text-gray-700" },
)
</script>

<template>
  <button
    type="button"
    class="flex size-7 cursor-pointer items-center justify-center rounded-full bg-white/90 transition-colors hover:bg-white"
    :class="color"
    :title="title"
    :disabled="disabled"
    @click.stop
  >
    <UIcon :name="icon" class="size-3.5" />
  </button>
</template>
